import React from 'react';

import { useTournamentState } from '@atlas/core';

import useIsSwipeGrid from 'common/Widgets/Tournament/useIsSwipeGrid';
import EventLoader from 'components/Pages/EventLoader';
import EventSwipeGridLoader from 'components/Pages/EventSwipeGridLoader';

const TournamentLoader = props => {
  const { initialized, loading } = useTournamentState();

  const isSwipeGrid = useIsSwipeGrid();

  if (!initialized && loading) {
    return (
      <div className="tournament-table-body-container">
        {isSwipeGrid ? <EventSwipeGridLoader /> : <EventLoader />}
      </div>
    );
  }

  return props.children;
};

export default TournamentLoader;
